export default __webpack_public_path__ + "static/media/sector_2.2b8d1142.jpg";